var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFilterIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8628 16.7052L6.4248 16.7052L6.4248 14.9552L17.8628 14.9552L17.8628 16.7052Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56527 17.5087C4.49231 17.5087 5.24383 16.7571 5.24383 15.8301C5.24383 14.9031 4.49231 14.1516 3.56527 14.1516C2.63823 14.1516 1.88672 14.9031 1.88672 15.8301C1.88672 16.7571 2.63823 17.5087 3.56527 17.5087ZM3.56527 19.2587C5.45881 19.2587 6.99383 17.7236 6.99383 15.8301C6.99383 13.9366 5.45881 12.4016 3.56527 12.4016C1.67173 12.4016 0.136719 13.9366 0.136719 15.8301C0.136719 17.7236 1.67173 19.2587 3.56527 19.2587Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.137178 5.04495L11.5752 5.04495L11.5752 3.29495L0.137178 3.29495L0.137178 5.04495Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4347 5.84841C13.5077 5.84841 12.7562 5.0969 12.7562 4.16986C12.7562 3.24282 13.5077 2.4913 14.4347 2.4913C15.3618 2.4913 16.1133 3.24282 16.1133 4.16986C16.1133 5.0969 15.3618 5.84841 14.4347 5.84841ZM14.4347 7.59841C12.5412 7.59841 11.0062 6.06339 11.0062 4.16986C11.0062 2.27632 12.5412 0.741302 14.4347 0.741302C16.3283 0.741302 17.8633 2.27632 17.8633 4.16986C17.8633 6.06339 16.3283 7.59841 14.4347 7.59841Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFilterIc);
export default __webpack_public_path__ + "static/media/MobileFilter_ic.814da6e9.svg";
export { ForwardRef as ReactComponent };